import { ObservableArray, View } from "binder"
import { NotificationsWindowViewModel, singleNotification } from "./notificationsWindow-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "../../windowContainer/IPopup";

export class NotificationsWindowView extends View<NotificationsWindowViewModel>{
    GetViewUniqueId(): string {
        return "V-FF8BD6E2-BFD7-4380-AF9C-5FA524AEAD11"
    }
    loadHtml(): string {
        let element = require('./notificationsWindow.html').default;
        let style = require('./notificationsWindow.less');
        return element;
    }
    constructor() {
       super();
    }

    public set notifications(v: ObservableArray<singleNotification>) { this._notifications = v; } public get notifications(): ObservableArray<singleNotification> { return this._notifications;} private _notifications: ObservableArray<singleNotification>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

}
